import { API_ENDPOINTS } from "constants";
import { useFetchData } from "./apiHooks";
import IconButtonWithTooltip from "components/buttons/IconButtonWithTooltip";
import { faEnvelopeCircleCheck, faEnvelopesBulk } from "@fortawesome/free-solid-svg-icons";
import MediaViewer from "components/common/MediaViewer";
import { useTranslation } from "react-i18next";
import { useList } from "./useList";
import { OBJ } from "constants";

export const useAccountSettingsOptions = () => {
    const { t } = useTranslation();
    const { list, isLoading, error, refetch } = useList(OBJ.ACCOUNT_SETTINGS, null, null, false, JSON.stringify({is_active: true, email_exclude: null}));
    const options = () => {
        const options = list?.items?.map(item => ({ 
            value: item.id, 
            label: item.email, 
            element: item.logo_upload_id ? 
                    <MediaViewer uploadId={item?.logo_upload_id} maxHeight={"32px"}/>
                :
                    <IconButtonWithTooltip translationId={item.email} icon={faEnvelopeCircleCheck} type="IconOnly" size="2xl"/>
        })) || [];

        options.unshift({
            value: null, 
            label: t('emails.dropdown.allAccountSettings'),
            element: <IconButtonWithTooltip translationId={'emails.dropdown.allAccountSettings'} icon={faEnvelopesBulk} type="IconOnly" size="2xl"/>
        });
        return options;
    };

    return { accountSettingsOptions: options(), isLoading, error, refetch };
};
